export default {
  teamTitle: 'Rejoignez notre équipe',
  teamText: `Nous cultivons l'excellence,\ntout comme nous le faisons avec nos levures.`,
  info: `Via Verdi,\n32 31046 Oderzo - TV\nItalie`,
}
